import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import ModalContentBase from '../redux/components/modal/modal_content_base';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    countriesPrefs: PropTypes.array.isRequired,
    circle: PropTypes.object.isRequired,
    handlePrefChange: PropTypes.func.isRequired,
  },
  closeModalPrefSelector() {
    this.modalPrefSelector.closeModal();
  },
  onChange () {
    this.props.handlePrefChange();
    setTimeout(() => {
      this.modalPrefSelector.closeModal();
    }, 100);
  },
  render() {
    const countriesPrefsArray = this.props.countriesPrefs;
    const optionId = this.props.circle[this.props.name];
    const countriesPrefPreviewContent = (
      <p className="nav-link link--arrow p-0 mb-0">
        {optionId
          ? `${countriesPrefsArray[optionId - 1]['name']}`
          : '主な活動地域を選択'}
      </p>
    );

    const countriesPrefs = countriesPrefsArray.map((pref) => {
      return (
        <li className="nav-item p-3 border-bottom" key={pref.id}>
          <input
            type="radio"
            name={this.props.name}
            id={`pref_${pref.id}`}
            className="d-none checkbox__input checkbox__area"
            value={pref.id}
            onChange={this.onChange}
            defaultChecked={
              this.props.name === 'pref_id'
                ? pref.id == this.props.circle.pref_id
                : pref.id == this.props.circle.meeting_pref_id
            }
          />
          <label
            className="d-flex justify-content-between align-items-center mb-0 position-relative"
            htmlFor={`pref_${pref.id}`}
          >
            <span className="p-0 line-height-2 pl-3 mb-0">{pref.name}</span>
            <span className="checkbox__lg checkbox__noborder" />
          </label>
        </li>
      );
    });

    const countriesPrefsBox = (
      <div className="card bg-gray pt-3">
        <button
          type="button"
          className="close close__modal position-absolute position--modalclose"
          aria-label="Close"
          onClick={this.closeModalPrefSelector}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h6 className="text-fw-bold text-center mb-3_5">
          地域を選択してください
        </h6>
        <div className="card bg-white h-100">
          <ul className="nav flex-column">{countriesPrefs}</ul>
        </div>
      </div>
    );

    return (
      <div>
        <ModalContentBase
          ref={(c) => {
            this.modalPrefSelector = c;
          }}
          previewContent={countriesPrefPreviewContent}
          modalContent={countriesPrefsBox}
        />
      </div>
    );
  },
});
